'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
export const BLENDER_DOWNLOAD_URL = 'https://www.blender.org/download/';
interface BuildLightmapDialogProps {
  open: boolean;
  blenderPath?: string;
  errorMessage?: string;
  invalidSelectionMessage?: string;
  canStart: boolean;
  canOpenSceneInBlender: boolean;
  isBusy: boolean;
  showInstallBlender: boolean;
  onCancel: () => void;
  onInstall: () => void;
  onBrowseForBlender: () => void;
  onOpenSceneInBlender: () => void;
  onResetBlenderPath: () => void;
  onDismissInvalidSelection: () => void;
  onStart: () => void;
}
export const BuildLightmapDialog = t0 => {
  const $ = _c(78);
  const {
    open,
    blenderPath,
    errorMessage,
    invalidSelectionMessage,
    canStart,
    canOpenSceneInBlender,
    isBusy,
    showInstallBlender,
    onCancel,
    onInstall,
    onBrowseForBlender,
    onOpenSceneInBlender,
    onResetBlenderPath,
    onDismissInvalidSelection,
    onStart
  } = t0;
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);
  let t1;
  if ($[0] !== onCancel) {
    t1 = nextOpen => {
      if (!nextOpen) {
        onCancel();
      }
    };
    $[0] = onCancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogHeader><DialogTitle>Build Lightmap</DialogTitle><DialogDescription>Confirm Blender is available, then start the lightmap bake for the active scene.</DialogDescription></DialogHeader>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-sm font-medium">Blender executable</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = blenderPath?.trim() ? blenderPath : "Not set \u2014 install Blender or browse for its executable below.";
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="space-y-1">{t3}<p className="text-sm text-muted-foreground break-all">{t4}</p></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== errorMessage) {
    t6 = errorMessage ? <p className="text-xs text-destructive">{errorMessage}</p> : null;
    $[6] = errorMessage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isBusy || $[9] !== onInstall || $[10] !== showInstallBlender) {
    t7 = showInstallBlender ? <Button type="button" variant="secondary" onClick={onInstall} disabled={isBusy}>Install Blender</Button> : null;
    $[8] = isBusy;
    $[9] = onInstall;
    $[10] = showInstallBlender;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isBusy ? "Checking..." : "Browse for Blender";
  let t9;
  if ($[12] !== isBusy || $[13] !== onBrowseForBlender || $[14] !== t8) {
    t9 = <Button type="button" variant="outline" onClick={onBrowseForBlender} disabled={isBusy}>{t8}</Button>;
    $[12] = isBusy;
    $[13] = onBrowseForBlender;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isBusy || !canOpenSceneInBlender;
  let t11;
  if ($[16] !== onOpenSceneInBlender || $[17] !== t10) {
    t11 = <Button type="button" variant="outline" onClick={onOpenSceneInBlender} disabled={t10}>Open Scene In Blender</Button>;
    $[16] = onOpenSceneInBlender;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setResetConfirmOpen(true);
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isBusy) {
    t13 = <Button type="button" variant="ghost" onClick={t12} disabled={isBusy}>Reset</Button>;
    $[20] = isBusy;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11 || $[23] !== t13 || $[24] !== t7 || $[25] !== t9) {
    t14 = <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">{t7}{t9}{t11}{t13}</div>;
    $[22] = t11;
    $[23] = t13;
    $[24] = t7;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== isBusy || $[28] !== onCancel) {
    t15 = <Button type="button" variant="ghost" onClick={onCancel} disabled={isBusy}>Cancel</Button>;
    $[27] = isBusy;
    $[28] = onCancel;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const t16 = !canStart || isBusy;
  let t17;
  if ($[30] !== onStart || $[31] !== t16) {
    t17 = <Button type="button" onClick={onStart} disabled={t16}>Start</Button>;
    $[30] = onStart;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t15 || $[34] !== t17) {
    t18 = <DialogFooter className="gap-2 sm:gap-0">{t15}{t17}</DialogFooter>;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t14 || $[37] !== t18 || $[38] !== t5 || $[39] !== t6) {
    t19 = <DialogContent className="max-w-md">{t2}{t5}{t6}{t14}{t18}</DialogContent>;
    $[36] = t14;
    $[37] = t18;
    $[38] = t5;
    $[39] = t6;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== open || $[42] !== t1 || $[43] !== t19) {
    t20 = <Dialog open={open} onOpenChange={t1}>{t19}</Dialog>;
    $[41] = open;
    $[42] = t1;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = Boolean(invalidSelectionMessage);
  let t22;
  if ($[45] !== onDismissInvalidSelection) {
    t22 = nextOpen_0 => {
      if (!nextOpen_0) {
        onDismissInvalidSelection();
      }
    };
    $[45] = onDismissInvalidSelection;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <AlertDialogTitle>Invalid Blender Executable</AlertDialogTitle>;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== invalidSelectionMessage) {
    t24 = <AlertDialogHeader>{t23}<AlertDialogDescription className="break-words">{invalidSelectionMessage}</AlertDialogDescription></AlertDialogHeader>;
    $[48] = invalidSelectionMessage;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== isBusy || $[51] !== onDismissInvalidSelection) {
    t25 = <AlertDialogFooter><AlertDialogAction disabled={isBusy} onClick={onDismissInvalidSelection}>OK</AlertDialogAction></AlertDialogFooter>;
    $[50] = isBusy;
    $[51] = onDismissInvalidSelection;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t24 || $[54] !== t25) {
    t26 = <AlertDialogContent>{t24}{t25}</AlertDialogContent>;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t21 || $[57] !== t22 || $[58] !== t26) {
    t27 = <AlertDialog open={t21} onOpenChange={t22}>{t26}</AlertDialog>;
    $[56] = t21;
    $[57] = t22;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <AlertDialogHeader><AlertDialogTitle>Reset Blender Path?</AlertDialogTitle><AlertDialogDescription>Your saved Blender executable path will be removed. The app will look for Blender in standard install locations instead.</AlertDialogDescription></AlertDialogHeader>;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== isBusy) {
    t29 = <AlertDialogCancel disabled={isBusy}>Cancel</AlertDialogCancel>;
    $[61] = isBusy;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== onResetBlenderPath) {
    t30 = () => {
      setResetConfirmOpen(false);
      onResetBlenderPath();
    };
    $[63] = onResetBlenderPath;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== isBusy || $[66] !== t30) {
    t31 = <AlertDialogAction disabled={isBusy} onClick={t30}>Reset</AlertDialogAction>;
    $[65] = isBusy;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t29 || $[69] !== t31) {
    t32 = <AlertDialogContent>{t28}<AlertDialogFooter>{t29}{t31}</AlertDialogFooter></AlertDialogContent>;
    $[68] = t29;
    $[69] = t31;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== resetConfirmOpen || $[72] !== t32) {
    t33 = <AlertDialog open={resetConfirmOpen} onOpenChange={setResetConfirmOpen}>{t32}</AlertDialog>;
    $[71] = resetConfirmOpen;
    $[72] = t32;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t20 || $[75] !== t27 || $[76] !== t33) {
    t34 = <>{t20}{t27}{t33}</>;
    $[74] = t20;
    $[75] = t27;
    $[76] = t33;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  return t34;
};
BuildLightmapDialog.displayName = 'BuildLightmapDialog';